// removed by extract-text-webpack-plugin
module.exports = {"container":"mG9pCO5sIVyc5iOBI6CDR","boxSection":"_33eS4hYTMou0mDfVGIHLeV","viewSection":"_2S_fMcmgsilxSaz-JyXID7","showItem":"Wf3WkfVBqxzwX8rv3L85k","boxContainer":"_2VSv5LBUIdZ-47qHAjK7zQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuickSend/QuickSends/QuickSends.scss
// module id = 1377
// module chunks = 1